import { render, staticRenderFns } from "./screenDisplay.vue?vue&type=template&id=f127ccfc&scoped=true&"
import script from "./screenDisplay.vue?vue&type=script&lang=js&"
export * from "./screenDisplay.vue?vue&type=script&lang=js&"
import style0 from "./screenDisplay.vue?vue&type=style&index=0&id=f127ccfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f127ccfc",
  null
  
)

export default component.exports